import { portalText } from "../../i18n/portal.js";
/**
 * What a voice test really does, said once so it cannot be worded two ways.
 *
 * AMENDED 2026-10-09 (design sync): the test panel's text disclosure is gone — the design's panel says
 * "Free. Nothing is billed for text tests." under the box, and the phone and browser modes say their
 * cost in the header and the foot.
 *
 * AMENDED 2026-10-09 (plan-015 TC1, GC, owner answer 16): the voice modes keep the design's short cost
 * line and add ONE sentence, only for a template whose test has a real-world effect: a delivery agent's
 * test order reaches the order book, and a booking agent's test booking is a real booking. Every other
 * template says nothing more. The long disclosure paragraph component that nothing drew any more is
 * deleted.
 *
 * There is nothing simulated about a voice test call: it runs on the live VoiceAgent over its real
 * connections and is billed like any other minute; `conversation.is_test` is what makes it a test.
 */

/**
 * The one real-effect sentence a voice test carries for this template (owner answer 16), or `null` when
 * the template's test has no effect outside WeTalk worth saying.
 */
export function testCallConsequenceOf(agentTemplateCode: string | undefined): string | null {
  switch (agentTemplateCode) {
    case "delivery":
      return portalText("operations", "a_test_order_goes_to_your_order_book_like_any_other_d53cbc05");
    case "booking":
      return portalText("operations", "a_test_booking_is_a_real_booking_dc27c56c");
    default:
      return null;
  }
}
